import { render } from "./top-nav.vue?vue&type=template&id=52483b2e&scoped=true"
import script from "./top-nav.vue?vue&type=script&lang=js"
export * from "./top-nav.vue?vue&type=script&lang=js"

import "./top-nav.vue?vue&type=style&index=0&id=52483b2e&lang=scss&scoped=true"

import exportComponent from "D:\\Desktop\\haorun-website-pc-dev\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52483b2e"]])

export default __exports__